import React from 'react';

const ComingSoonPage = () => {
  return (
    <div style={{ position: 'fixed', inset: 0, background: '#000', WebkitFontSmoothing: 'antialiased' }}>
      {/* Grain */}
      <div style={{
        position: 'absolute', inset: 0, opacity: 0.025, pointerEvents: 'none', zIndex: 200,
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
      }} />

      {/* Video */}
      <div style={{ position: 'absolute', inset: 0, zIndex: 5, overflow: 'hidden' }}>
        <video
          autoPlay muted loop playsInline
          style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.75 }}
        >
          <source src="/px-11-bw-4k.mp4" type="video/mp4" />
        </video>
      </div>

      {/* Vignette */}
      <div style={{
        position: 'absolute', inset: 0, zIndex: 10, pointerEvents: 'none',
        background: 'radial-gradient(ellipse at 50% 50%, transparent 25%, rgba(0,0,0,0.2) 50%, rgba(0,0,0,0.7) 100%)'
      }} />

      {/* Content */}
      <div style={{
        position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', zIndex: 50, textAlign: 'center'
      }}>
        <h1 style={{ lineHeight: 1 }}>
          <span style={{
            display: 'block', fontFamily: "'Cormorant Garamond', serif",
            fontSize: 'clamp(52px, 9vw, 110px)', fontWeight: 300, color: '#fafafa', letterSpacing: '0.03em'
          }}>Secret</span>
          <span style={{
            display: 'block', fontFamily: "'Outfit', sans-serif",
            fontSize: 'clamp(64px, 11vw, 140px)', fontWeight: 200, color: '#fafafa',
            letterSpacing: '0.05em', marginTop: '4px'
          }}>13</span>
        </h1>
        <p style={{
          fontFamily: "'Outfit', sans-serif", fontSize: '12px', fontWeight: 400,
          color: '#52525b', marginTop: '24px', letterSpacing: '0.15em'
        }}>between us...</p>
      </div>

      {/* Dates — bottom left */}
      <div style={{ position: 'absolute', bottom: 0, left: '16px', zIndex: 50, textAlign: 'left' }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '12px', marginBottom: '10px' }}>
          <span style={{
            fontFamily: "'Outfit', sans-serif", fontSize: 'clamp(11px, 1.2vw, 14px)',
            fontWeight: 400, letterSpacing: '0.25em', textTransform: 'uppercase', color: '#c9b896'
          }}>July 13</span>
          <span style={{
            fontFamily: "'Outfit', sans-serif", fontSize: '12px', fontWeight: 400,
            color: '#52525b', letterSpacing: '0.15em'
          }}>Dubai</span>
        </div>
        <div style={{ width: '30px', height: '1px', background: 'rgba(139,115,85,0.2)', margin: '6px 0 14px' }} />
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '12px', marginBottom: '10px' }}>
          <span style={{
            fontFamily: "'Outfit', sans-serif", fontSize: 'clamp(11px, 1.2vw, 14px)',
            fontWeight: 400, letterSpacing: '0.25em', textTransform: 'uppercase', color: '#c9b896'
          }}>October 13</span>
          <span style={{
            fontFamily: "'Outfit', sans-serif", fontSize: '12px', fontWeight: 400,
            color: '#52525b', letterSpacing: '0.15em'
          }}>Al Marjan Island</span>
        </div>
      </div>

      {/* Credit — bottom right */}
      <div style={{ position: 'absolute', bottom: 0, right: '16px', zIndex: 50, textAlign: 'right' }}>
        <div style={{
          fontFamily: "'Outfit', sans-serif", fontSize: '10px', letterSpacing: '0.2em', color: '#3f3f46'
        }}>by</div>
        <div style={{
          fontFamily: "'Outfit', sans-serif", fontSize: '11px', letterSpacing: '0.15em', color: '#52525b', marginTop: '4px'
        }}>Alldooz.com</div>
      </div>
    </div>
  );
};

export default ComingSoonPage;
